/**
 * Temporary header name used during the removal of Json API standard.
 * Added as a header to requests using the JSON API Standard to request a standard response
 * TODO: OR-2133 - Remove this contact once all endpoints have been completely refactored
 */
export const NEW_RESPONSE_HEADER = 'new-response';
